export default class HashMenu {
    static init() {
        Array.from(document.querySelectorAll('.hash-menu')).forEach(element => {
            new HashMenu(element);
        });
    }

    classes = {
        node: 'hash-menu',
        items: 'hash-menu__item',
        links: 'hash-menu__link'
    }

    constructor(element) {
        if (window.innerWidth <= 1024) return;

        if (!element) return;
        this.element = element;
        this.itemsArray = Array.from(this.element.querySelectorAll(`.${this.classes.items}`));
        this.linksArray = Array.from(this.element.querySelectorAll(`.${this.classes.links}`));
        this.ScrollspySectionElement = document.querySelector(`.scrollspy-sections`);
        this.currentElement = this.element.querySelector(`.${this.classes.links}--is-active`);
        this.newElement = {};

        // window scroll event
        let headerElement = document.querySelector('.header');
        let headerHeight = headerElement ? headerElement.offsetHeight : 0;
        let gap = 15;

        if (!this.currentElement) {
            this.currentElement = this.linksArray[0];
            this.currentElement.classList.add(`${this.classes.links}--is-active`);
        }

        if (!this.linksArray.length) return;

        window.addEventListener('scroll', () => {
            this.linksArray.forEach(el => {
                if (el.hash.length === 0) return;

                let targetElement = document.querySelector(el.hash);
                if (!targetElement) return;
                let targetPosition = targetElement.getBoundingClientRect().y;

                if (targetPosition < window.innerHeight - headerHeight - gap) {
                    this.newElement = el.hash === '#' + targetElement.id ? el : this.newElement;
                }
            });

            if (!(this.newElement instanceof HTMLElement)) return;

            if (!this.currentElement.isSameNode(this.newElement)) {
                this.currentElement.classList.remove(`${this.classes.links}--is-active`);
                this.newElement.classList.add(`${this.classes.links}--is-active`)
                this.currentElement = this.newElement;

                let hash = this.currentElement.href.replace(location.href.replace(location.hash, ''), '');

                if (hash) {
                    let newHref = location.href.replace(location.hash, '') + hash;
                    history.replaceState({}, '', newHref);
                }
            }
        });

        this.detectPinkTextOnPinkBackgroundAndChangeColor();
    }

    detectPinkTextOnPinkBackgroundAndChangeColor() {
        // the active element is pink and becomes invisible over pink backgrounds
        // On scroll we always check the background color of the element behind the active element

        // We'll store all pink sections as an array of {top, bottom}
        let pinkSections;

        // For performance, we'll throttle checks with requestAnimationFrame
        let scrolling = false;

        let spacingValue = 0;

        const calculatePinkSections = () => {
            return Array.from(document.querySelectorAll('.after\\:bg-primary')).map(el => {
                const rect = el.getBoundingClientRect();
                const top = rect.top + window.scrollY;
                const bottom = rect.bottom + window.scrollY;
                return { top, bottom };
            });
        }

        function calculateSpacingValue() {
            // Suppose your CSS has :root { --spacing: 60px; }
            const rootStyles = getComputedStyle(document.documentElement);

            // Get the raw string, e.g. "60px"
            const spacingRaw = rootStyles.getPropertyValue('--spacing').trim();

            // If you need just the numeric value, remove "px"
            return parseInt(spacingRaw, 10);
        }

        const checkPinkBackground = () => {
            const newSpacingValue = calculateSpacingValue();
            if (newSpacingValue !== spacingValue) { // header height changed
                spacingValue = newSpacingValue;
                pinkSections = calculatePinkSections();
            }
            Array.from(this.element.querySelectorAll(`.${this.classes.links}--on-pink-background`)).forEach(el => {
                el.classList.remove(`${this.classes.links}--on-pink-background`);
            });

            this.linksArray.forEach(el => {
                const rect = el.getBoundingClientRect();

                // Get the vertical midpoint of the element relative to the entire page
                const linkMidY = window.scrollY + rect.top + rect.height / 2;

                // Determine if that midpoint is inside any pink section
                const isOverPink = pinkSections.some(section =>
                    linkMidY >= section.top && linkMidY <= section.bottom
                );

                el.classList[isOverPink ? 'add' : 'remove'](`${this.classes.links}--on-pink-background`);
            });
        };

        const rafLoop = () => {
            if (scrolling) {
                scrolling = false;
                checkPinkBackground();
            }
            requestAnimationFrame(rafLoop);
        }

        // init
        pinkSections = calculatePinkSections();
        spacingValue = calculateSpacingValue();

        // Initial check (in case page loads scrolled somewhere)
        checkPinkBackground();

        // Start the requestAnimationFrame loop
        rafLoop();

        // On scroll, set 'scrolling' to true
        window.addEventListener('scroll', () => {
            scrolling = true;
        });
        window.addEventListener('resize', () => {
            // If layout changes, recalc bounding boxes:
            pinkSections = calculatePinkSections();
            scrolling = true;
        });
    }
}
